import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/F_Presentation.svg"

const FPresentation: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 16 18'} component={Icon} {...props} fill="currentColor" />
export default FPresentation
